/**
 * @generated SignedSource<<5952f7cead34eb6af9a55dc5c08b1a36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StakeholdersCategoryAssignInputObject = {
  categoryId: string;
  stakeholderIds: ReadonlyArray<string>;
};
export type stakeholdersCatPage_AssignMutation$variables = {
  input: StakeholdersCategoryAssignInputObject;
};
export type stakeholdersCatPage_AssignMutation$data = {
  readonly stakeholdersCategoryAssign: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholders: ReadonlyArray<{
      readonly id: string;
    }> | null | undefined;
  } | null | undefined;
};
export type stakeholdersCatPage_AssignMutation = {
  response: stakeholdersCatPage_AssignMutation$data;
  variables: stakeholdersCatPage_AssignMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholders",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholdersCatPage_AssignMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StakeholdersCategoryAssignMutationPayload",
        "kind": "LinkedField",
        "name": "stakeholdersCategoryAssign",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stakeholdersCatPage_AssignMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StakeholdersCategoryAssignMutationPayload",
        "kind": "LinkedField",
        "name": "stakeholdersCategoryAssign",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b7cec5fcc2b6315ff2f277ac3908bad0",
    "id": null,
    "metadata": {},
    "name": "stakeholdersCatPage_AssignMutation",
    "operationKind": "mutation",
    "text": "mutation stakeholdersCatPage_AssignMutation(\n  $input: StakeholdersCategoryAssignInputObject!\n) {\n  stakeholdersCategoryAssign(input: $input) {\n    stakeholders {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a85d2ce96cf5b74262576c73ee07a439";

export default node;
